"use strict";

var _interopRequireWildcard3 = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));

var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));

var _objectSpread2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var report = _interopRequireWildcard3(require("@/api/report"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    dateFrom: {
      type: String
    },
    dateTo: {
      type: String
    },
    userId: {
      type: Number
    },
    level: {
      type: Number
    }
  },
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      dialogVisible: false,
      listQuery: {
        page: 1,
        limit: 10,
        userId: this.userId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      },
      loadingButtonExcel: false,
      loading: false
    };
  },
  methods: {
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    downloadReport: function downloadReport() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var tHeader, filterVal, res, dataRes;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tHeader = ["Master Agent", "Distributor", "Retailer", "Employee", "Seller", "Enrollment number", "Active time", "First call made", "First call date", "ESN", "Imei", "Found in inventory", "Device type", "Device model"];
                filterVal = ["lv1Name", "lv2Name", "lv3Name", "lv4Name", "sellerName", "enrollmentNumber", "activeTime", "firstCallMade", "firstCallDate", "esn", "imei", "foundInInventory", "deviceType", "deviceModel"];
                _this.loadingButtonExcel = true;
                _context.next = 5;
                return report.getSaleReport((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.listQuery), {}, {
                  level: _this.level,
                  page: undefined,
                  limit: undefined
                }));

              case 5:
                res = _context.sent;
                dataRes = res.data.data;
                Promise.resolve().then(function () {
                  return (0, _interopRequireWildcard2.default)(require("@/vendor/Export2Excel"));
                }).then(function (excel) {
                  var list = dataRes;

                  var data = _this.formatJson(filterVal, list);

                  excel.export_json_to_excel({
                    header: tHeader,
                    data: data,
                    filename: "Report sale detail"
                  });
                  _this.loadingButtonExcel = false;
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getTableData: function getTableData() {
      var _this2 = this;

      this.dialogVisible = true;
      this.listQuery.userId = this.userId;
      this.listQuery.dateFrom = this.dateFrom;
      this.listQuery.dateTo = this.dateTo;
      this.loading = true;
      report.getSaleReport((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
        level: this.level
      })).then(function (res) {
        _this2.tableData = res.data.data;
        _this2.total = res.data.total;
      }).finally(function () {
        _this2.loading = false;
        _this2.loadingButton = false;
      });
    }
  }
};
exports.default = _default;